// extracted by mini-css-extract-plugin
module.exports = {"selectedOption":"style__selectedOption__wv4CX"};